import React, { useEffect, useRef } from 'react';
var SnippylyPresence = function (props) {
    var maxUsers = props.maxUsers, inactivityTime = props.inactivityTime, offlineInactivityTime = props.offlineInactivityTime, documentParams = props.documentParams, location = props.location, locationId = props.locationId, self = props.self, onPresenceUserClick = props.onPresenceUserClick, onUsersChanged = props.onUsersChanged, onPresenceUserChange = props.onPresenceUserChange, disableFlockNavigation = props.disableFlockNavigation, defaultFlockNavigation = props.defaultFlockNavigation, onNavigate = props.onNavigate, flockMode = props.flockMode, shadowDom = props.shadowDom;
    var ref = useRef();
    var onUsersChangedRef = useRef(onUsersChanged);
    var onPresenceUserChangeRef = useRef(onPresenceUserChange);
    var onNavigateRef = useRef(onNavigate);
    var onPresenceUserClickRef = useRef(onPresenceUserClick);
    // Update the ref to always point to the latest callback function
    useEffect(function () {
        onUsersChangedRef.current = onUsersChanged;
    }, [onUsersChanged]);
    useEffect(function () {
        onPresenceUserChangeRef.current = onPresenceUserChange;
    }, [onPresenceUserChange]);
    useEffect(function () {
        onNavigateRef.current = onNavigate;
    }, [onNavigate]);
    useEffect(function () {
        onPresenceUserClickRef.current = onPresenceUserClick;
    }, [onPresenceUserClick]);
    useEffect(function () {
        var element;
        var handlePresenceUserChange = function (event) {
            if (onUsersChangedRef.current) {
                onUsersChangedRef.current(event === null || event === void 0 ? void 0 : event.detail);
            }
            if (onPresenceUserChangeRef.current) {
                onPresenceUserChangeRef.current(event === null || event === void 0 ? void 0 : event.detail);
            }
        };
        var handleNavigate = function (event) {
            if (onNavigateRef.current) {
                onNavigateRef.current(event === null || event === void 0 ? void 0 : event.detail);
            }
        };
        var handlePresenceUserClick = function (event) {
            if (onPresenceUserClickRef.current) {
                onPresenceUserClickRef.current(event === null || event === void 0 ? void 0 : event.detail);
            }
        };
        if (ref.current) {
            element = ref.current;
            if (element) {
                element.addEventListener('onPresenceUserChange', handlePresenceUserChange);
                element.addEventListener('onNavigate', handleNavigate);
                element.addEventListener('onPresenceUserClick', handlePresenceUserClick);
            }
        }
        return function () {
            if (element) {
                element.removeEventListener('onPresenceUserChange', handlePresenceUserChange);
                element.removeEventListener('onNavigate', handleNavigate);
                element.removeEventListener('onPresenceUserClick', handlePresenceUserClick);
            }
        };
    }, []);
    return (React.createElement("velt-presence", { ref: ref, "flock-mode": [true, false].includes(flockMode) ? (flockMode ? 'true' : 'false') : undefined, "max-users": maxUsers, "inactivity-time": inactivityTime, "offline-inactivity-time": offlineInactivityTime, "document-params": (typeof documentParams === 'object') ? JSON.stringify(documentParams) : (documentParams ? documentParams : undefined), "disable-flock-navigation": [true, false].includes(disableFlockNavigation) ? (disableFlockNavigation ? 'true' : 'false') : undefined, "default-flock-navigation": [true, false].includes(defaultFlockNavigation) ? (defaultFlockNavigation ? 'true' : 'false') : undefined, self: [true, false].includes(self) ? (self ? 'true' : 'false') : undefined, location: (typeof location === 'object') ? JSON.stringify(location) : (location ? location : undefined), "location-id": locationId, "shadow-dom": [true, false].includes(shadowDom) ? (shadowDom ? 'true' : 'false') : undefined }));
};
export default SnippylyPresence;
